import { Svg } from 'common/assets'
import { StyledBrand } from '../Main/styled'
import {
  AnimatedImage,
  Container,
  ContantContainer,
  DesktopWrap,
  ImageContainer,
  LinksList,
  MobileImagesWrap,
  MobileTextDescription,
  Title,
  TitleWrapper,
} from './styled'
import { useTranslation } from 'react-i18next'
import { useContext } from 'react'
import { LandingContext } from 'common/contexts/Landing/Landing'
import { baseURL } from 'models'

export const BanquetMain = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const { landing } = useContext(LandingContext)
  const description = landing?.banketDescription?.find(
    el => el.lang === language,
  )?.value

  return (
    <Container>
      <ContantContainer>
        <StyledBrand src={Svg.SignOne} alt="icon brand" />
        <TitleWrapper>
          <Title>{t('banquetTitle')}</Title>
        </TitleWrapper>
        <MobileImagesWrap $count={landing?.banketMainImages?.length}>
          {landing?.banketMainImages?.map((item, i) => (
            <AnimatedImage
              key={item}
              src={baseURL + '/public/' + item}
              alt={`photo` + i + 1}
            />
          ))}
        </MobileImagesWrap>
        <DesktopWrap>
          <ImageContainer>
            <AnimatedImage
              src={baseURL + '/public/' + landing?.banketMainImages?.[0]}
            />{' '}
            <p>{description}</p>
          </ImageContainer>
          <ImageContainer>
            <AnimatedImage
              src={baseURL + '/public/' + landing?.banketMainImages?.[1]}
            />
            <AnimatedImage
              src={baseURL + '/public/' + landing?.banketMainImages?.[2]}
            />
          </ImageContainer>
        </DesktopWrap>
        <LinksList>
          {landing?.banketTerms && (
            <a
              target="_blank"
              rel="noreferrer noopener"
              href={baseURL + '/public/' + landing?.banketTerms}>
              {t('conditions')}
            </a>
          )}
          {landing?.banketMenu && (
            <a
              rel="noreferrer noopener"
              target="_blank"
              href={baseURL + '/public/' + landing?.banketMenu}>
              {t('menu')}
            </a>
          )}
          {landing?.banketContactPhone && (
            <a href={`tel:${landing?.banketContactPhone?.replace(/\D/g, '')}`}>
              {landing?.banketContactPhone.toUpperCase()}
            </a>
          )}
        </LinksList>
        <MobileTextDescription>{description}</MobileTextDescription>
      </ContantContainer>
    </Container>
  )
}
